module.exports = __webpack_public_path__ + "static/media/08.6cd53e3c.jpg";